module.exports = __webpack_public_path__ + "static/media/Pending.524e565e.svg";